import React, { Component } from "react";
import { translate  } from '../../helpers/intl_helpers';
import { upperCaseOfName, callBackendAPI, generateSource, cancelToken   } from '../../helpers/common';
import { AGREEMENT_TYPE_DROPDOWN, ADMIN, DISPATCHER, ACTIVE, PROFILE_INACTIVE, STATUS_SUCCESS } from '../../config/global_constants';
import { NavLink as Link} from "react-router-dom";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip'

import Auth from './../../helpers/Auth';

import callIcon 	from '../../assets/images/call-icon.svg';
import mailIcon 	from '../../assets/images/mail-icon.svg';
import editIcon 	from '../../assets/images/edit-icon.svg';
import infoIcon     from '../../assets/images/info-icon.svg';

export default class SubcontractorDetailModal extends Component {
	source;

	constructor(props){
        super(props)
		this.state = {
			missingDoc: [],
			expiredDoc: [],
			requestDetails: {}
		};
    }

	renderTooltip = (props) => {
		const { missingDoc, expiredDoc } = this.state;

		return (
			<Tooltip id="button-tooltip" {...props}>
			{missingDoc?.length > 0 && (
				<div>
				<strong>Missing:</strong> {missingDoc.join(', ')}
				</div>
			)}

			{expiredDoc?.length > 0 && (
				<div>
				<strong>Expired:</strong> {expiredDoc.join(', ')}
				</div>
			)}

			{!missingDoc?.length && !expiredDoc?.length && (
				<div>No missing or expired documents.</div>
			)}
			</Tooltip>
		);
	};


	componentDidMount() {
		const { profileDetails } = this.props;

		if(profileDetails?.subcontract_request_id){
			/** Generate source for cancel token */
			this.source = generateSource();

			window.showLoader();

			let apiParams = [
				{ model: "contracts", method: "getSubcontractorDocsStatus", subcontractor_id: profileDetails?.subcontract_request_id },
				{ model: "employee", method: "subcontractorFormDetails", subcontractor_id: profileDetails?.subcontract_request_id},
			];

			/** Call API */
			callBackendAPI(apiParams,this.source).then(response => {
				if(response.success && response.data[0].status === STATUS_SUCCESS) {
					const subDetails= response?.data?.[1]?.request_details ?? {};
					this.setState({requestDetails: subDetails});
					this.setState({
						missingDoc: response.data[0].missing_documents,
						expiredDoc: response.data[0].expired_documents
					});
					window.hideLoader();
				}
			}).catch(err => console.log(err));
		}
	}

	componentWillUnmount(){
		cancelToken(this.source); // cancel the request
	}

	/**
	* For hide model
	*
	* @return null
	*/
	// closeModal(){
    //     window.closeModal('subcontractorDetailModal');
	// }// end closeModal()

	/** Function to handle image lightbox */
	handleImageClick = (imageUrl) => {
		this.setState({
			lightBoxShow	: true,
			selectedImage	: imageUrl
		});
	}


	render() {
		const { profileDetails, fileUrl, noImgUrl, toggleModal, closeModal } = this.props;

		return (
			<>
			<div className="modal fade crew-modal" id="subcontractorDetailModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-bs-backdrop="static" >
				<div className="modal-dialog modal-xl">
					<div className="modal-content">
						<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={()=> {closeModal()} }>X Close</button>

						<div className="modal-body">
							<h3>{profileDetails.full_name ? profileDetails.full_name : translate('calendar.details')}</h3>
							<div className="list-group list-group-flush">
								<ul className="details-listing">
									<li>
										<div className="profile-detail-box">
											<span className={`sort-name ${(!profileDetails.image) ? 'greenbg' : ''}`}>
												{profileDetails && profileDetails.image ? (
													<img src={`${fileUrl}${profileDetails.image}`} alt="employee" onError={(event) => event.target.src = noImgUrl} onClick={() => this.handleImageClick(`${fileUrl}${profileDetails.image}`)} />
												) : (
													upperCaseOfName(profileDetails.first_name ? profileDetails.first_name : "", profileDetails.last_name ? profileDetails.last_name : "")
												)}
											</span>
											<div>
												<div className="inner-wrap">
													<p>{translate('employee.status')}</p>
													{/* <span className={profileDetails.active ? "text-success" : "text-danger"}> */}
													<span className={profileDetails?.active === ACTIVE ? 'text-success' : 'text-danger'}>

														{
															profileDetails?.active === ACTIVE ? translate('employee.active') :
															profileDetails?.active === PROFILE_INACTIVE ? translate('employee.inactive') :
															<span className='text-danger'>
																{translate('employee.suspended')}
																{
																	this.state.missingDoc?.length || this.state.expiredDoc?.length ?
																		<OverlayTrigger
																			placement="top"
																			delay={{ show: 250, hide: 400 }}
																			overlay={this.renderTooltip}
																			>
																			<img
																				src={infoIcon}
																				className="ms-1"
																				alt="info-icon"
																				style={{ cursor: 'pointer' }}
																			/>
																		</OverlayTrigger>
																	: null
																}
															</span>
														}
													</span>
												</div>
											</div>
										</div>
									</li>
									<li>
										<div className="inner-wrap">
											<p>{translate('subcontractor.contact_name')}</p>
											<span>{profileDetails.contact_name ? profileDetails.contact_name : "N/A"}</span>
										</div>
									</li>
									<li>
										<div className="inner-wrap">
											<p>{translate('subcontractor.email')}</p>
											<div>
												<img src={mailIcon} alt="img" width={19} height={21} />
												{profileDetails.email ? (
													<a href={`mailto:${profileDetails.email}`} className="text-lowercase email-link">
														{profileDetails.email}
													</a>
												) : "N/A"}
											</div>
										</div>
									</li>
									<li>
										<div className="inner-wrap">
											<p>{translate('subcontractor.mobile')}</p>
											<div>
												<img src={callIcon} alt="img" width={19} height={21} />
												{profileDetails.mobile ? (
													<a href={`tel:${profileDetails.mobile}`}>{profileDetails.mobile}</a>
												) : "N/A"}
											</div>
										</div>
									</li>
									<li>
										<div className="inner-wrap">
											<p>{translate('subcontractor.project_manager')}</p>
											<span>{profileDetails.project_manager ? profileDetails.project_manager : "N/A"}</span>
										</div>
									</li>
									<li>
										<div className="inner-wrap">
											<p>{translate('subcontractor.vendor_code')}</p>
											<span>{profileDetails.vendor_code ? profileDetails.vendor_code : "N/A"}</span>
										</div>
									</li>
									<li>
										<div className="inner-wrap">
											<p>{translate('subcontractor.street')}</p>
											<span>{profileDetails.street ? profileDetails.street : "N/A"}</span>
										</div>
									</li>
									<li>
										<div className="inner-wrap">
											<p>{translate('subcontractor.city')}</p>
											<span>{profileDetails.city ? profileDetails.city : "N/A"}</span>
										</div>
									</li>
									<li>
										<div className="inner-wrap">
											<p>{translate('subcontractor.state')}</p>
											<span>{profileDetails.state ? profileDetails.state : "N/A"}</span>
										</div>
									</li>
									<li>
										<div className="inner-wrap">
											<p>{translate('subcontractor.zip')}</p>
											<span>{profileDetails.zip ? profileDetails.zip : "N/A"}</span>
										</div>
									</li>
									<li>
										<div className="inner-wrap">
											<p>{translate('subcontractor.flagging_company')}</p>
											<span>{profileDetails.is_flagger ? "Yes" : "No"}</span>
										</div>
									</li>
									{/* <li>
										<div className="inner-wrap">
											<p>{translate('subcontractor.agreement_type')}</p>
											<span>{AGREEMENT_TYPE_DROPDOWN.find(item => item.value === profileDetails.agreement_type)?.label || "N/A"}</span>
										</div>
									</li> */}
									{this.state?.requestDetails?.company_list?.length &&
										this.state?.requestDetails?.company_list?.map((val, index) => (
											<li className='w-100' key={index}>
												<div className="inner-wrap" key={index}>
													{index === 0 && (
														<p>{translate("Company's Agreement Type")}</p>
													)}
													<span>
														{(val?.name || "N/A") + " - " +
															(
																AGREEMENT_TYPE_DROPDOWN.find(
																	item => item.value === this.state?.requestDetails?.agreement_data?.[val?._id]
																)?.label || "N/A"
															)
														}
													</span>
												</div>
											</li>
										))
									}
								</ul>
							</div>
							{([ADMIN, DISPATCHER].indexOf(Auth.getPermission()) !== -1) &&
								<div className="detail-modal-editbtns">
									<Link to="#" onClick={() => toggleModal(true, profileDetails._id)}>
										<img src={editIcon} alt="img" width={21} height={21} />
										Edit
									</Link>
								</div>
							}
						</div>
					</div>
				</div>
			</div>
			</>
		)
	}
}
